import React from 'react';

import styled, { keyframes } from 'styled-components';

import grey from 'sushiweb/tokens/color/grey';
import white from 'sushiweb/tokens/color/white';
import { P } from 'sushiweb/Typography/Text';
import Input from 'sushiweb/InputTypes/Input';
import red from 'sushiweb/tokens/color/red';
import green from 'sushiweb/tokens/color/green';
import Layout from 'sushiweb/Layout/Layout';
import { getBrowser } from '../../../../../../utility';
import { uploadErrorStatus } from '../../../../../common/components/constants';

export const FileSVG = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='18'
      height='18'
      viewBox='0 0 18 18'
      fill='none'
    >
      <path
        d='M15.75 6V15.7449C15.75 16.1626 15.4164 16.5 15.0049 16.5H2.99504C2.5837 16.5 2.24999 16.167 2.24999 15.7561V2.24385C2.24999 1.84148 2.58652 1.5 3.00165 1.5H11.2476L15.75 6ZM14.25 6.75H10.5V3H3.74999V15H14.25V6.75ZM5.99999 5.25H8.24999V6.75H5.99999V5.25ZM5.99999 8.25H12V9.75H5.99999V8.25ZM5.99999 11.25H12V12.75H5.99999V11.25Z'
        fill='#EF4F5F'
      />
    </svg>
  );
};

export const SingleLineArrow = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='18'
      height='18'
      viewBox='0 0 18 18'
      fill='none'
    >
      <path
        d='M12.1287 8.25163L8.1057 4.22863L9.16635 3.16797L15 9.00163L9.16635 14.8352L8.1057 13.7746L12.1287 9.75163H3V8.25163H12.1287Z'
        fill='white'
      />
    </svg>
  );
};

export const ClearFileUploadCross = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
    >
      <g clipPath='url(#clip0_9327_39942)'>
        <path
          d='M8 0C3.6 0 0 3.6 0 8C0 12.4 3.6 16 8 16C12.4 16 16 12.4 16 8C16 3.6 12.4 0 8 0ZM10.72 9.84C10.96 10.08 10.96 10.48 10.72 10.72C10.64 10.8 10.48 10.88 10.32 10.88C10.16 10.88 10 10.8 9.92 10.72L8 8.88L6.16 10.72C6.08 10.8 5.92 10.88 5.76 10.88C5.6 10.88 5.44 10.8 5.36 10.72C5.12 10.48 5.12 10.08 5.36 9.84L7.12 8L5.28 6.16C5.04 5.92 5.04 5.52 5.28 5.28C5.52 5.04 5.92 5.04 6.16 5.28L8 7.12L9.84 5.28C10.08 5.04 10.48 5.04 10.72 5.28C10.96 5.52 10.96 5.92 10.72 6.16L8.88 8L10.72 9.84Z'
          fill='#AFB4C0'
        />
      </g>
      <defs>
        <clipPath id='clip0_9327_39942'>
          <rect width='16' height='16' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export const FundsSummaryIcon = () => {
  return (
    <svg
      width='48'
      height='48'
      viewBox='0 0 48 48'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <circle
        cx='24'
        cy='24'
        r='23.75'
        fill='#FEFAEC'
        stroke='#FCEEC0'
        strokeWidth='0.5'
      />
      <g clipPath='url(#clip0_15036_24673)'>
        <path
          d='M24 12C17.373 12 12 17.373 12 24C12 30.627 17.373 36 24 36C30.627 36 36 30.627 36 24C36 17.373 30.627 12 24 12ZM26.592 30.768C25.968 31.008 25.464 31.2 25.104 31.344C24.732 31.466 24.303 31.537 23.858 31.537C23.832 31.537 23.806 31.537 23.781 31.536H23.785C23.74 31.539 23.688 31.54 23.635 31.54C23.016 31.54 22.448 31.321 22.005 30.956L22.009 30.96C21.625 30.628 21.384 30.14 21.384 29.597C21.384 29.579 21.384 29.56 21.385 29.542V29.545C21.377 29.444 21.373 29.327 21.373 29.209C21.373 29.091 21.377 28.974 21.386 28.858L21.385 28.873C21.385 28.633 21.457 28.393 21.529 28.081L22.321 25.321C22.393 25.033 22.441 24.793 22.489 24.553C22.545 24.36 22.579 24.138 22.585 23.908V23.905C22.588 23.877 22.59 23.844 22.59 23.81C22.59 23.561 22.497 23.333 22.344 23.16L22.345 23.161C22.149 23.021 21.904 22.938 21.64 22.938C21.592 22.938 21.546 22.941 21.499 22.946L21.505 22.945C21.281 22.95 21.067 22.985 20.864 23.045L20.881 23.041L20.329 23.233L20.545 22.369C21.049 22.153 21.553 21.985 22.033 21.817C22.442 21.68 22.912 21.601 23.401 21.601C23.409 21.601 23.418 21.601 23.426 21.601H23.425C23.474 21.598 23.531 21.596 23.588 21.596C24.191 21.596 24.746 21.806 25.182 22.157L25.177 22.153C25.506 22.486 25.709 22.945 25.709 23.45C25.709 23.492 25.708 23.533 25.705 23.574V23.568C25.705 23.712 25.705 23.904 25.705 24.216C25.681 24.526 25.63 24.812 25.553 25.088L25.561 25.056L24.769 27.816C24.721 28.04 24.665 28.296 24.601 28.584C24.564 28.773 24.538 28.996 24.529 29.223V29.232C24.525 29.263 24.523 29.299 24.523 29.335C24.523 29.582 24.616 29.807 24.769 29.977L24.768 29.976C24.989 30.113 25.257 30.195 25.544 30.195C25.575 30.195 25.605 30.194 25.636 30.192H25.632C25.866 30.184 26.088 30.15 26.3 30.091L26.28 30.096C26.485 30.04 26.66 29.975 26.828 29.895L26.808 29.904L26.592 30.768ZM26.448 19.512C26.115 19.81 25.672 19.992 25.187 19.992C25.175 19.992 25.163 19.992 25.15 19.992H25.152C25.138 19.992 25.122 19.993 25.105 19.993C24.604 19.993 24.148 19.801 23.806 19.487L23.807 19.488C23.466 19.183 23.253 18.743 23.253 18.252C23.253 17.761 23.466 17.321 23.805 17.017L23.807 17.016C24.134 16.731 24.564 16.556 25.036 16.556C25.077 16.556 25.117 16.557 25.157 16.56H25.152C25.153 16.56 25.154 16.56 25.155 16.56C25.659 16.56 26.115 16.762 26.449 17.088C26.783 17.396 26.991 17.836 26.991 18.324C26.991 18.812 26.783 19.252 26.45 19.559L26.449 19.56L26.448 19.512Z'
          fill='#F3C117'
        />
      </g>
      <defs>
        <clipPath id='clip0_15036_24673'>
          <rect
            width='24'
            height='24'
            fill='white'
            transform='translate(12 12)'
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const uploadBtnStyle = {
  width: '1000px',
  height: '54px',
  borderRadius: '5px',
  border: '1px dashed var(--redred-500, #EF4F5F)',
  background: '#FFF5F6',
  cursor: 'pointer',
};

export const disabledUploadBtnStyle = {
  width: '1000px',
  height: '54px',
  borderRadius: '5px',
  border: '0.5px dashed var(--coolgreycoolgrey-500, #9197A6)',
  background: 'var(--coolgreycoolgrey-100, #F2F4F7)',
  cursor: 'pointer',
};

export const uploadFileText = {
  marginTop: getBrowser() === 'Safari' ? '-105px' : '-140px',
  fontWeight: 200,
};

export const downloadBtnStyle = {
  background: grey.z100,
  color: '#293142',
  border: '0px',
};
export const clearFileBtnStyle = {
  background: grey.z100,
  color: '#293142',
  border: '0px',
  padding: '0px',
  marginTop: '-6px',
};

export const chipsStyle = {
  chipBg: grey.z200,
  chipFont: grey.z800,
  chipCross: grey.z800,
};

export const ModalFieldsWrapper = styled.div`
  margin-top: 10px;
  border-top: 1.5px solid #f2f4f7;
  // width: 700px;
`;
export const ModalSuccessWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  h5 {
    font-weight: 500;
  }
  p {
    margin: 1rem 0 2.4rem;
    font-size: 1.6rem;
  }
`;

export const CreateGroupModalFooter = styled.div`
  display: flex;
  width: 95%;
  height: 100%;
  min-height: 63px;
  padding: 2rem 3rem;
  justify-content: space-between;
  align-items: center;
  margin: 10px 0 0 0;
  border-radius: 10px;
  background: ${props => (props.unsuccessful ? grey.z100 : green.z200)};
  border 0.1rem solid ${props => (props.unsuccessful ? grey.z200 : green.z400)};
  h5 {
    color: ${props => (props.unsuccessful ? grey.z800 : green.z700)};
  }
  }
`;

export const UnsuccessfulUploadText = styled.div`
  h5 {
    font-weight: 500;
    font-size: 1.6rem;
  }
  h6 {
    padding-top: 0.5rem;
    font-size: 1.3rem;
  }
  align-items: center;
  justify-content: center;
`;
export const UnsuccessfulDownloadText = styled.a`
  display: inline-flex;
  padding: 12px 20px;
  align-items: center;
  border-radius: 12px;
  border: 0px solid var(--redred-100, #ffedef);
  background: var(--basewhite-000, #fff);
`;
export const UnsuccessfulDownloadBtn = styled.div`
  display: inline-flex;
  padding: 2px 6px;
  align-items: center;
  border-radius: 12px;
  border: 0px solid var(--redred-100, #ffedef);
  background: var(--basewhite-000, #fff);
  color: var(--coolgreycoolgrey-800, #414a5d);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
`;
export const UploadIconWhite = styled.div`
  padding-left: 5px;
  width: 16px;
  height: 16px;
  flex-shrink: 0;
`;
export const StyledP = styled(P)`
  font-size: 1.8rem;
  font-weight: 400;
  color: '#1C1C1C';
  margin-bottom: 1.5rem;
`;

export const DottedLine = styled.div`
  border-top: 1px dotted #e6e9ef;
  margin-top: 1rem;
  width: 100%;
`;

export const CreateButtonWrapper = styled.div`
  margin-top: 42px;
  display: flex;
  justify-content: space-between;
`;

export const FormWrapper = styled.div`
  width: 100%;
  margin-top: 1.4rem;
  background: ${white};
  border: 0.1rem solid ${grey.z200};
  border-radius: 0.8rem;
  padding: 3.4rem 2.6rem;
  h5 {
    margin-bottom: 2.4rem;
  }
`;

export const UploadFileWrapper = styled.div`
  width: 100%;
  margin-top: 1.4rem;
  margin-top: ${props => (props.isToast ? '0' : '1.4rem')};
  background: ${grey.z100};
  border: 0.1rem solid ${grey.z200};
  border-radius: 0.8rem;
  padding: ${props => (props.isAddEmployee ? '3rem 1.6rem' : '1.4rem 1.6rem')};
`;
export const CreateTeamHelperText = styled.span`
  color: var(--coolgreycoolgrey-400, #afb4c0);
  font-size: 12px;
  margin-top: -10px;
`;
export const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  p {
    font-size: 1.6rem;
    margin-bottom: 1rem;
    color: ${grey.z900};
  }
`;
InputWrapper.HelperText = styled.div`
  font-size: 1.3rem;
  margin-top: 0.8rem;
  color: ${grey.z600};
`;
export const StyledLayout = styled(Layout)`
  margin-bottom: 1.3rem;
  margin-top: 1.3rem;
`;

export const StyledInput = styled(Input)`
  margin-top: 1.2rem;
  width: 100%;
`;
export const UploadSectionContainer = styled.div`
  padding: 2rem;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  flexdirection: row;
  padding: 1.7rem 1.2rem;
  justify-content: center;
  h6 {
    margin-top: 1.6rem;
    justify-content: center;
    align-items: center;
    font-size: 1.8rem;
  }
`;

export const ClearFileUploadCrossWrapper = styled.div`
  padding-top: 10px;
  display: flex;
`;

export const TextWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 1rem 0.1rem 1.5rem 1.2rem;
  overflow: hidden;
  h6 {
    font-size: 1.5rem;
    margin-bottom: 1rem;
  }
  p {
    color: ${grey.z600};
    font-size: 1.2rem;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
`;

const move = keyframes`
  0% {
    background-position: 0 0;
  }
  100% {
    background-position: 50px 50px;
  }
`;

export const ConfirmUpload = styled.div`
  -webkit-transition: visibility 0s, opacity 0.2s linear;
  -moz-transition: visibility 0s, opacity 0.2s linear;
  transition: visibility 0s, opacity 0.2s linear;
  opacity: ${props =>
    props.show && !uploadErrorStatus.includes(props.status) ? 1 : 0};
  display: ${props =>
    props.show && !uploadErrorStatus.includes(props.status) ? 'block' : 'none'};
  overflow: hidden;
  width: 95%;
  margin: 1.6rem auto 0;
  max-width: 130rem;
  padding: 2rem 3rem;
  font-weight: 500;
  color: ${props =>
    uploadErrorStatus.includes(props.status) ? red.z700 : green.z700};
  font-size: 1.6rem;
  border-radius: 1rem;
  border: ${props =>
    uploadErrorStatus.includes(props.status)
      ? `0.1rem solid ${red.z400}`
      : `0.1rem solid ${green.z400}`};
  background-color: ${props =>
    uploadErrorStatus.includes(props.status) ? red.z200 : green.z200};
  position: relative;
  &:after {
    display: ${props => (props.progress ? 'block' : 'none')};
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background-image: linear-gradient(
      -45deg,
      rgba(255, 255, 255, 0.2) 25%,
      transparent 25%,
      transparent 50%,
      rgba(255, 255, 255, 0.2) 50%,
      rgba(255, 255, 255, 0.2) 75%,
      transparent 75%,
      transparent
    );
    background-size: 50px 50px;
    animation: ${move} 2s linear infinite;
  }
`;

export const FundsSummaryText = styled.div`
  flex-direction: column;

  h4 {
    color: ${grey.z800};
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
  }
  h5 {
    color: ${grey.z800};
    font-size: 16px;
    font-style: normal;
    font-weight: 1000;
  }
  h6 {
    text-align: center;
    color: ${grey.z500};
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    margin-top: 8px;
    line-height: 22px; /* 137.5% */
  }
  h2 {
    text-align: right;
    color: ${red.z600};
    font-size: 15px;
    font-style: normal;
    margin-top: 8px;
    font-weight: 600;
    line-height: 22px; /* 137.5% */
  }
`;

export const PaymentMethodText = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  // padding-top: 1rem;

  & > h2 {
    color: ${grey.z800};
    font-size: 18px;
    font-family: 'Lexend-500';
  }
  h1 {
    word-wrap: break-word;
    white-space: normal;
    text-align: center;
    color: ${grey.z500};
    font-size: 15px;
    font-style: normal;
    font-weight: 200;
    margin-top: 8px;
    line-height: 22px; /* 137.5% */
  }
`;

export const GiftingPlanResponseStateWrapper = styled.div`
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  h5 {
    font-weight: 500;
    margin-top: 2.8rem;
  }
  p {
    margin: 1rem 0 2.4rem;
    font-size: 1.6rem;
  }
`;

export const LinkWrapper = styled.div`
  width: 50rem;
  display: flex;
  border: 1px solid ${green.z300};
  background: ${green.z100};
  padding: 0.5rem;
  margin-top: 1rem;
  border-radius: 5px;
  overflow: scroll;
  text-overflow: scroll;
  white-space: nowrap;
`;

export const LinkWrapperSpan = styled.span`
  display: flex;
  overflow: scroll;
  text-overflow: scroll;
  white-space: nowrap;
  padding: 0.5rem;
`;
